<style scoped>
    .search-item {
        margin-top : 0px;
        margin-bottom : 0px;
    }
    .item-td {
        cursor:pointer;
    }
    .second-row {
        display: flex;
        font-size: 15px;
    }
    .sendTo {
        height: 20px;
        margin-right: 3%;
        text-align: center;
    }
    .from {
        width: 50px;
        background-color: lightgray;
    }
    .to {
        width: 30px;
        margin-left: 5%;
        color: white;
        background-color: gray;
    }
    .v-input--checkbox {
        margin-right: 30px;
    }
    .info-to{
        width: 300px;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }    
    .pleft{
        padding-left: 30px !important;
    }
    .page-per{
        font-weight: bolder;
        font-size: 16px;
    }
    .v-table-header{
        list-style: none;
        margin: 15px 10px;
        padding-left: 0 !important;
        font-size: 18px !important;
    }
    .v-table-header li{
        display: inline-block;
        width: 48%;
    }
    .v-table-header li:first-child{
        text-align: left;
    }
    .v-table-header li:last-child{
        text-align: right;
    }
    .text-field{
        background-color: #FFFFFF;
    }
    .white-space-nowrap{
        max-width: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

</style>
<template>
    <v-container fluid>
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">締結済み一覧</v-col>
            </v-row>
        </v-container>
        <v-row justify="center">
            <v-col cols="12">
                <ul class="v-table-header">
                    <li class="text-field">
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          :height="25"
                          placeholder="件名、契約先、承認者、署名者を入力してください"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                    </li>
                    <li class="page-per">
                        <page_offset_limit_component :total="total" :items_per_page="items_per_page" :page="page"></page_offset_limit_component>    
                    </li>
                </ul>
                <v-data-table
                    :headers="headers"
                    :items="filterItems"
                    :page.sync="page"
                    :items-per-page="items_per_page"
                    @page-count="page_count = $event"
                    hide-default-footer
                    class="elevation-1"
                >
                    <template v-slot:body="props">
                            <tbody>
                                <tr v-for="(item, index) in props.items" :key="index" @click="itemAction(item.object_id)">
                                    <td class="item-td white-space-nowrap" align="left">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-to"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.contract_name }}
                                                </span>
                                            </template>
                                            <span>{{ item.contract_name }}</span>
                                        </v-tooltip>

                                        <div class="second-row">
                                            <div class="sendTo to">To</div>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span
                                                    class="info-to"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                        {{ item.to_destination_user_names }}
                                                    </span>
                                                </template>
                                                <span>{{ item.to_destination_user_names }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="left">
                                        <div class="second-row" v-if="item.to_destination_company_names != ''" >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span
                                                    class="info-to"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    >
                                                        {{ item.to_destination_company_names }}
                                                    </span>
                                                </template>
                                                <span>{{ item.to_destination_company_names }}</span>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                    <td class="item-td white-space-nowrap" align="center">{{ getDateWithWeekTimeText(item.conclusion_date) }}</td>
                                </tr>
                            </tbody>
                    </template>
                </v-data-table>
                <v-pagination
                    v-model="page"
                    :length="page_count"
                ></v-pagination>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
    import page_offset_limit_component from '../../components/common/PageOffsetLimitComponent.vue';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    import {search_symbol} from '../../common/validationCustomRules.js';
    export default {
        data() {
            return {
                search:"",
                // ページ数
                page: 1,
                // 最大ページ数
                page_count: 0,
                // 1ページあたりの項目数
                items_per_page: 10,
                //総件数
                total:0,
                // テーブルヘッダー
                headers: [
                    { text: "件名", value: "contract_name", align: "center", width: "25%", sortable: false},
                    { text: "契約先", value: "to_destination_company_names", align: "left", width: "20%", sortable: true},
                    { text: "締結日", value: "conclusion_date", align: "center", width: "20%", sortable: true, filterable: false},
                ],
            };
        },
        computed: {
            filterItems() {
                let search = this.search;
                let items = this.items.filter(function(item) {
                    if(item.to_destination_user_name_list.findIndex((name) => (name.indexOf(search) !== -1)) !== -1){
                        return true;
                    }else if(item.to_destination_company_name_list?.findIndex((name) => (name.indexOf(search) !== -1)) !== -1){
                        return true;
                    }else if(item.contract_name.indexOf(search) !== -1) {
                        return true;
                    }
                    return false;
                });
                this.total = items.length;
                return items;
            }
        },
        mixins:[dateformatMixin],
        components: {
            page_offset_limit_component,
        },
        props: {
            navi : [],
            items : Array
        },
        mounted() {
            this.setTotal();
        },
        methods: {
            setTotal() {
                this.total = this.items.length;
            },
            // 契約書概要へのリンク
            itemAction(object_id) {
                window.location.href = "/documents/document-management/summary/" + object_id;
            },
        },
    };
</script>
